import { getClientInformation } from '../../connection/util/functions';
var AuthenticationByTokenRequest = (function () {
    function AuthenticationByTokenRequest(token, maximumIdleInterval) {
        this.token = token;
        this.maximumIdleInterval = maximumIdleInterval;
    }
    AuthenticationByTokenRequest.prototype.toJson = function () {
        var clientInformation = getClientInformation();
        return {
            Message: 'AuthenticationByTokenRequest',
            Version: 1,
            token: {
                value: this.token
            },
            software: JSON.stringify(clientInformation),
            os: clientInformation.platform,
            feature_flags_wanted: {
                value: 0
            },
            maximum_idle_interval: this.maximumIdleInterval,
            maximum_receivable_message_size: 1048576,
            flags: 0,
            cache_authentication_salt: {
                value: []
            },
            cache_authentication_encrypted_secret: {
                encrypted_secret: []
            }
        };
    };
    return AuthenticationByTokenRequest;
}());
export { AuthenticationByTokenRequest };
//# sourceMappingURL=AuthenticationByTokenRequest.js.map